module.exports = __webpack_public_path__ + "static/media/8.a9085df1.jpg";